import React from "react";

const ModalDocumentos = ({
  cotizaciones,
  solpeds,
  ocs,
  handleDocEntryChange,
  addDocEntry,
  removeDocEntry,
  handleSaveDocEntries,
  handleClose,
}) => {
  const renderEntries = (entries, type, label, icon) => (
    <div className="modal-doc-section">
      <div className="modal-doc-section-header">
        <span>
          <i className={icon}></i> {label}
        </span>
        <span className="modal-doc-badge">
          {entries.filter((e) => e.nro).length}
        </span>
      </div>
      <div className="modal-doc-section-body">
        {entries.map((entry, i) => (
          <div className="modal-doc-entry" key={`${type}-${i}`}>
            <div className="modal-doc-field">
              <label>Nro</label>
              <input
                type="text"
                placeholder="Ej: 12345"
                value={entry.nro}
                onChange={(e) =>
                  handleDocEntryChange(type, i, "nro", e.target.value)
                }
              />
            </div>
            <div className="modal-doc-field">
              <label>Fecha</label>
              <input
                type="date"
                value={entry.fecha ? entry.fecha.substring(0, 10) : ""}
                onChange={(e) =>
                  handleDocEntryChange(type, i, "fecha", e.target.value)
                }
              />
            </div>
            <button
              type="button"
              className="modal-doc-remove"
              title="Eliminar"
              onClick={() => removeDocEntry(type, i)}
            >
              <i className="fa-solid fa-xmark"></i>
            </button>
          </div>
        ))}
        <button
          type="button"
          className="modal-doc-add"
          onClick={() => addDocEntry(type)}
        >
          <i className="fa-solid fa-plus"></i> Agregar {label}
        </button>
      </div>
    </div>
  );

  return (
    <>
      <div className="container-modal" onClick={handleClose}></div>
      <div className="modal-doc-wrapper">
        <div className="modal-doc-header">
          <div className="modal-doc-header-left">
            <i className="fa-solid fa-file-invoice"></i>
            <div>
              <h3>Documentos Contables</h3>
              <p>Gestiona cotizaciones, solpeds y órdenes de compra</p>
            </div>
          </div>
          <button
            type="button"
            className="modal-doc-close"
            onClick={handleClose}
          >
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>
        <div className="modal-doc-content">
          {renderEntries(
            cotizaciones || [],
            "cotizaciones",
            "Cotización",
            "fa-solid fa-file-lines",
          )}
          {renderEntries(
            solpeds || [],
            "solpeds",
            "Solped",
            "fa-solid fa-file-export",
          )}
          {renderEntries(ocs || [], "ocs", "OC", "fa-solid fa-file-contract")}
        </div>
        <div className="modal-doc-footer">
          <button
            type="button"
            className="modal-doc-btn-cancel"
            onClick={handleClose}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="modal-doc-btn-save"
            onClick={(e) => {
              handleSaveDocEntries(e);
              handleClose();
            }}
          >
            <i className="fa-solid fa-floppy-disk"></i> Guardar Documentos
          </button>
        </div>
      </div>
    </>
  );
};

export default ModalDocumentos;
